export const validatePhoneNumberRegex =
  /\(?\d+\)?[-.\s]?\d+[-.\s]?\d+[0-9]{1,10}$/;
